import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "components__cnt-tiles" }
const _hoisted_2 = { class: "jump-tiles" }
const _hoisted_3 = { class: "jump-tile-description" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "jump-tile-button-spacer" }

import { computed } from 'vue';
  import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-tiles',
  props: {...cntProps()},
  setup(__props) {

  const props = __props;
  
  const saneTiles = computed(() => (props.contentItem.widget_data.jump_tiles || []).sort((a, b) => a.position - b.position)) 

return (_ctx: any,_cache: any) => {
  const _component_simple_button = _resolveComponent("simple-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saneTiles.value, (jumpTile, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["jump-tile", [jumpTile.theming.border, jumpTile.theming.light_background]])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["jump-tile-icon", [jumpTile.theming.normal]])
          }, [
            (jumpTile.icon_name)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(jumpTile.icon_name)
                }, null, 2))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              innerHTML: jumpTile.description_html
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(jumpTile.button_label), 1),
          _createVNode(_component_simple_button, {
            class: _normalizeClass(["jump-tile-button", [jumpTile.theming.inverted, jumpTile.theming.hover_box]]),
            filled: "",
            "link-target": jumpTile.button_target,
            "use-incognito-theming": !!jumpTile.theming.use_theming
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(jumpTile.button_label), 1)
            ]),
            _: 2
          }, 1032, ["link-target", "use-incognito-theming", "class"])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})